import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import SoftwarePreview from "./components/SoftwarePreview";
import Steps from "./components/Steps";
import Faq from "./components/Faq";
import Contacts from "./components/Contacts";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";

function Home() {
    return (
        <div className="min-h-screen">
            <Navbar />
            <Hero />
            <Features />
            <SoftwarePreview />
            <Steps />
            <Faq />
            <Contacts />
            <Footer />
            <BackToTop />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
